<template>
  <div class="recharge_left capital_first">
    <div class="transport">
      <div class="tranport_title">{{ $t("pc.strategyHistoryDetails.number") }}:{{order}}</div>
      <div class="tranport_content">
        <div class="history_title">
          <ul class="first">
            <li>
              <div>{{ $t("pc.strategyHistoryDetails.total_strategic_funds") }}</div>
              <div>{{total}}</div>
            </li>
            <li>
              <div>{{ $t("pc.strategynow.applied_limit")}}</div>
              <div>{{apply_quota}}</div>
            </li>
            <li>
              <div>{{ $t("pc.strategynow.risk_margin") }}</div>
              <div>{{bond}}</div>
            </li>
          </ul>
          <ul>
            <li>
              <div>{{ $t("pc.strategynow.profit_distribution") }}</div>
              <div>{{divided}}</div>
            </li>
            <li>
              <div>{{ $t("pc.strategynow.loss_warning_line") }}</div>
              <div>{{warning}}</div>
            </li>
            <li>
              <div>{{ $t("pc.operate.loss_close_line") }}</div>
              <div>{{close}}</div>
            </li>
          </ul>
        </div>
        <div class="history_title second">
          <div style="text-align: left;margin-bottom: 10px;font-weight: 700;color: #666;">{{ $t("pc.strategyHistoryDetails.contract_details") }}</div>
          <ul>
            <li>
              <div>
                {{ $t("pc.strategyHistoryDetails.strategy_capital") }}
                <span style="font-weight: 600;">{{total}}</span>
              </div>
              <div>{{$t("pc.strategyHistoryDetails.start_time")}}：{{this.$getDeviceTime(time[0])}}</div>
            </li>
            <li>
              <div>
                {{$t("pc.strategyHistoryDetails.trading_type")}}：
                <span style="font-weight: 600;">
                  <span style="color: #566B96;">{{type}}</span>
                </span>
              </div>
              <div>{{$t("pc.strategyHistoryDetails.end_time")}} ：{{this.$getDeviceTime(time[1])}}</div>
            </li>
            <li>
              <div>
                {{$t("pc.strategyHistoryDetails.trading_profit_loss")}} ：
                <span v-bind:style="profit>0?'color: #FF2626':'color: #00B259;'">{{profit>0?profit:loss}}</span>
              </div>
              <div>{{$t("pc.operate.mangement_fee")}}：{{manage}}</div>
            </li>
          </ul>
        </div>
        <div class="history_title second">
          <div style="text-align: left;overflow: hidden;margin-bottom: 10px;font-weight: 700;">
            <span style="color: #666;">{{ $t("pc.strategyHistoryDetails.trading_proft_distribution") }}</span>
            <span style="float: right;color: #999;font-size: 14px;font-weight: 700;">{{ $t("pc.strategyHistoryDetails.settled") }}</span>
          </div>
          <ul>
            <li>
              <div>
                {{$t("pc.strategyHistoryDetails.profit_distribution")}} ：
                <span style="font-weight: 600; color: #FF2626;">{{profit}}</span>
              </div>
            </li>
            <li>
              <div>
                {{$t("pc.strategyHistoryDetails.loss_compensation")}}：
                <span style="font-weight: 700;color: #999;">{{loss}}</span>
              </div>
            </li>
          </ul>
        </div>
        <div class="history_title second third">
          <div style="text-align: left;overflow: hidden;margin-bottom: 10px;font-weight: 700;">
            <span style="color: #666;">{{ $t("pc.strategyHistoryDetails.performance_bond_settlement") }}</span>
            <span style="float: right;color: #999;font-size: 14px;">{{ $t("pc.strategyHistoryDetails.settled") }}</span>
          </div>
          <ul>
            <li>
              <div>
                {{$t("pc.strategyHistoryDetails.freeze")}} ：
                <span style="font-weight: 600; color: #566B96;">{{bond}}</span>
              </div>
            </li>
            <li>
              <div>
                {{$t("pc.strategyHistoryDetails.deduction")}}：
                <span style="font-weight: 700;color: #999;">{{deduction}}</span>
              </div>
            </li>
            <li>
              <div>
                {{$t("pc.strategyHistoryDetails.unfreeze")}}：
                <span style="font-weight: 700;color: #333;">{{thaw}}</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="history_apply">{{ $t("pc.strategyHistoryDetails.history_transactions") }}<a href="javascript:void(0);" class="red" @click="getCapitalData">({{ $t("pc.strategyHistoryDetails.click_to_view_fund_details") }})</a></div>
    <ul class="entrust_ul2">
      <li class="entrust_li1">
        <span>{{ $t("pc.strategyHistoryDetails.stock_name") }}</span>
        <span>{{ $t("pc.strategyHistoryDetails.buy_sell_direction") }}</span>
        <span>{{ $t("pc.strategyHistoryDetails.number_of_shares") }}</span>
        <span>{{ $t("pc.trading.transaction_sold_price") }}</span>
        <span>{{ $t("pc.strategyHistoryDetails.trans_status") }}</span>
        <!-- <span>成交市值</span> -->
        <span>{{ $t("pc.tradingquery.transaction_time") }}</span>
      </li>
      <li v-for="(item,index) in trade" :key="index">
        <span>
          <small class="font_weigth">{{item.name}}</small> ({{item.code}})
        </span>
        <span style="color: #00B259;">{{item.type}}</span>
        <span>{{item.number}}</span>
        <span>
          ￥
          <small class="font_weigth up_green">{{item.price}}</small>
        </span>
        <span style="color: #666;">{{item.status}}</span>
        <!-- <span>{{item.number}}</span> -->
        <span>{{this.$getDeviceTime(item.time)}}</span>
      </li>
    </ul>
    <el-dialog :title="$t('pc.trading.statement')" :visible.sync="capitalState">
      <el-table
        height="500px"
        size="small"
        border
        :data="capitalData"
        stripe
        style="width: 100%">
        <el-table-column
          type="index"
          align="center"
          width="50">
        </el-table-column>
        <el-table-column
          :formatter="formatTime"
          :label="$t('pc.trading.time')"
          align="center">
        </el-table-column>
        <el-table-column
          prop="name"
          :label="$t('pc.trading.stock')"
          align="center">
        </el-table-column>
        <el-table-column
          prop="type"
          :label="$t('pc.trading.type')"
          align="center">
        </el-table-column>
        <el-table-column
          prop="number"
          :label="$t('pc.trading.amount')"
          align="center">
        </el-table-column>
        <el-table-column
          prop="balance"
          :label="$t('pc.trading.balance')"
          align="center">
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="capitalState = false">{{ $t("pc.capital.withdraw.bankcard_popup_confirm_button") }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import $ from "jquery";
export default {
  name: "Strategyhistorydetails",
  data() {
    return {
      name: "", //策略名称
      order: "", //策略单号
      time: ["", ""], //策略时间
      proportion: "", //盈亏比例
      profit: "", //盈利金额
      loss: "", //亏损金额
      deduction: "", //扣除数量
      thaw: "", //解冻数量
      total: "", //总策略资金
      manage: "", //管理费
      type: "", //交易品种
      capital_total: "", //配资金额
      apply_quota: "", //申请金额
      bond: "", //保证金
      divided: "", //盈利分配
      warning: "", //预警线
      close: "", //平仓线
      trade: [], //交易记录
      capitalState:false,
      capitalData:[]
    };
  },
  mounted: function() {
    this.getInfo();
  },
  methods: {
      formatTime(row) {
      return this.$getDeviceTime(row.time); 
    },
    getInfo() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "history_detailed",
            token: sessionStorage.getItem("token"),
            cid: sessionStorage.getItem("cid")
          }
        })
        .then(function(res) {
          if (res.data.code == 1) {
            that.name = res.data.data.info.name;
            that.order = res.data.data.info.order;
            that.time = res.data.data.info.time.split("~");
            that.proportion = res.data.data.info.proportion;
            that.profit = res.data.data.info.profit;
            that.deduction = res.data.data.info.deduction;
            that.total = res.data.data.info.total;
            that.manage = res.data.data.info.manage;
            that.type = res.data.data.info.type;
            that.capital_total = res.data.data.info.capital_total;
            that.apply_quota = res.data.data.info.apply_quota;
            that.bond = res.data.data.info.bond;
            that.divided = res.data.data.info.divided;
            that.warning = res.data.data.info.warning;
            that.close = res.data.data.info.close;
            that.loss = res.data.data.info.loss;
            that.thaw = res.data.data.info.thaw;
            that.trade = res.data.data.trade;
          } else if (res.data.code == 0) {
            that.$message.error(that.$t(res.data.msg));
          }
        });
    },
    getCapitalData(){
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            'nozzle': 'capital_log',
            'token': window.sessionStorage.getItem('token'),
            'cid': sessionStorage.getItem("cid")
          }
        }).then(res => {
        if (res.data.code == 1) {
          that.capitalData = res.data.data;
          that.capitalState = true;
        } else if (res.data.code == 0 || res.data.code == -1) {
          that.$message.error(that.$t(res.data.msg));
        }
      });
    }
  }
};
</script>
<style scoped>
.capital_p1 > a:nth-child(1) {
  border: 0;
}
.transport {
  width: 1000px;
  border: 1px solid #ddd;
  margin-top: 20px;
}
.tranport_title {
  height: 85px;
  line-height: 85px;
  background-color: #faf3ea;
  font-size: 16px;
  font-weight: 700;
  padding-left: 30px;
}
.tranport_content {
  width: 100%;
  height: 694px;
}
.history_title {
  margin: 40px;
  padding-bottom: 24px;
  border-bottom: 1px solid #ddd;
}
.history_title .first {
  list-style: none;
  margin: 40px 0;
}
.history_title ul {
  overflow: hidden;
}
.history_title ul li {
  width: 30%;
  float: left;
  text-align: center;
  line-height: 40px;
}
.second {
  border-bottom: 1px dashed #ddd;
}
.third {
  border: 0;
}
.history_apply {
  width: 100%;
  height: 45px;
  line-height: 45px;
  margin: 40px 0 20px 0;
  border-bottom: 1px solid #ddd;
  font-weight: 600;
}
.entrust_ul2 {
  width: 100%;
}
.entrust_ul2 > li > span:nth-child(1) {
  width: 160px;
  margin-left: 25px;
}
.entrust_ul2 > li > span:nth-child(2) {
  width: 97px;
}
.entrust_ul2 > li > span:nth-child(3) {
  width: 124px;
}
.entrust_ul2 > li > span:nth-child(4) {
  width: 125px;
}
.entrust_ul2 > li > span:nth-child(5) {
  width: 123px;
}
.entrust_ul2 > li > span:nth-child(6) {
  width: 140px;
}
.entrust_ul2 > li > span:nth-child(7) {
  width: 190px;
}
</style>





// WEBPACK FOOTER //
// src/components/strategyhistorydetails.vue